import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "TipoContato";
export const Listar = (tipoContato) =>
  RequestWebApi.get(`/${controller}/Listar`, {
    params: { ...tipoContato },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const tiposContato = resultData;
      return { success, tiposContato };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { tiposContato: [] };
    });

export const Detalhes = (tipoContatoId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { tipoContatoId: tipoContatoId },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const tipoContato = resultData;
      return { success, tipoContato };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors, tipoContato: {} };
    });

export const Incluir = (tipoContato) =>
  RequestWebApi.post(`/${controller}/Incluir`, tipoContato)
    .then(function (response) {
      const { resultData, success } = response.data;
      const novoProduto = resultData;
      return { success, novoProduto };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Atualizar = (tipoContato) =>
  RequestWebApi.put(`/${controller}/Atualizar`, tipoContato)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Remover = (tipoContatoId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { tipoContatoId: tipoContatoId },
  })
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });
